<ng-container>
    @if (
        {
            widget: premiumWidget$ | async,
            hasOnlineDiscount: hasOnlineDiscount(),
        };
        as data
    ) {
        <div
            [style.backgroundColor]="primaryColour"
            class="py-[14px] relative text-sub-1">
            <div class="overflow-hidden">
                @if (displayCallCenterPremium()) {
                    <div
                        class="text-xs relative flex justify-between opacity-70 pb-1">
                        <div class="line-through">
                            {{
                                data.widget.formObject.txtCallCentre.details
                                    .text
                            }}
                        </div>
                        <div
                            [isLoading]="isLoading()"
                            [theme]="{
                                margin: 0,
                                height: '26px',
                                right: 0,
                            }"
                            libLoader
                            position="absolute"
                            zIndex="1">
                            <div class="line-through min-w-[100px] text-right">
                                {{
                                    premiumDifference()?.differences
                                        ?.baseDifference | currency: 'R'
                                }}
                                p/m
                            </div>
                        </div>
                    </div>
                }
                <div class="text-xs font-medium relative flex justify-between">
                    <div
                        [ngClass]="
                            hasOnlineDiscount() ? 'mt-[2px]' : 'self-center m-0'
                        ">
                        {{
                            data.widget.formObject.txtOnlinePremium.details.text
                        }}
                    </div>
                    <div
                        [isLoading]="isLoading()"
                        [theme]="{
                            margin: 0,
                            height: '26px',
                            right: 0,
                        }"
                        libLoader
                        position="absolute"
                        zIndex="1">
                        <div class="min-w-[100px] text-right text-xl">
                            {{ premiumDisplay() | currency: 'R' }}
                            p/m
                        </div>
                    </div>
                </div>
            </div>
            @if (hasOnlineDiscount()) {
                <div class="font-bold flex absolute left-0 -ml-3">
                    <div class="strip-shadow-variant opacity-50"></div>
                    <div
                        [style.backgroundColor]="discountColour"
                        class="text-sub-11 font-bold text-xs py-1 px-2">
                        {{
                            data.widget.formObject.txtDiscountText.details.text
                        }}
                    </div>
                </div>
            }
        </div>
    }
</ng-container>
